import { featureAtom } from "@sunrise/feature-flags";

export const searchEnabledAtom = featureAtom("search-enabled", false, {
  description: `Feature flag to enable search functionality in the main menu.`,
});
